// @ts-nocheck
export default (obj, attr, value) => (obj[attr] = value)
